import { render, staticRenderFns } from "./Lpq.vue?vue&type=template&id=2ab781bb&"
import script from "./Lpq.vue?vue&type=script&lang=js&"
export * from "./Lpq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports